module.exports = __webpack_public_path__ + "static/media/netflix-clone.ea7f5e60.webp";